export default __webpack_public_path__ + "static/media/dojoBg.7e57e4ad.png";